import Izzi61 from './Izzi 6 (1).webp'
import Izzi62 from './Izzi 6 (2).webp'
import Izzi63 from './Izzi 6 (3).webp'
import Izzi64 from './Izzi 6 (4).webp'
import Izzi65 from './Izzi 6 (5).webp'
import Izzi66 from './Izzi 6 (6).webp'
import Izzi67 from './Izzi 6 (7).webp'
import Izzi68 from './Izzi 6 (8).webp'
import Izzi69 from './Izzi 6 (9).webp'

const Izzi6images =[
Izzi61,Izzi62,Izzi63,Izzi64,Izzi65,Izzi66,Izzi67,Izzi68,Izzi69
]

export default Izzi6images;
